 <div class="container w-75  ms-4 me-4">
    <div class="d-flex justify-content-end mt-5 mb-5">
        <button type="button" mat-button class="fs-3 btn btn-primary" (click)="closeEventDialog()">X</button>
    </div>
    <h4 mat-dialog-title>{{ data.message }}</h4>
    <div mat-dialog-content>
        <div class="row">
            <div class="col-12 mb-3">
                {{description}}
            </div>
        </div>
        <div class="mt-2 mt-4 mb-4 border-bottom">
            <form #f="ngForm" [formGroup]="productForm">
                <mat-radio-group class="mb-4" #remove (change)="onRemoveSelected($event)" formControlName="removetype">
                    <mat-radio-button color="primary"  value="archive">
                        Archive
                    </mat-radio-button>
                    <mat-radio-button color="warn" value="delete">
                        Permanently Delete
                    </mat-radio-button>
                </mat-radio-group>
                <div class="row mt-4 mb-4">
                    @if(mode == "delete"){
                        <mat-checkbox (change)="onCheckboxChange($event.checked)">
                            I understand. Once the event is permanently deleted, images and videos cannot be restored.
                        </mat-checkbox>
                    }
                </div>
                <div class="row mt-4 mb-4">
                    @if(removeSelected) {
                        <div class="col-6">
                            <button type="button" mat-button class="fs-5 btn btn-secondary" (click)="onRemove(false)">
                                Cancel
                            </button>
                        </div>
                        @if(allowDelete){
                            <div class="col-6">
                                <button type="button" mat-button class="fs-5 btn btn-danger" (click)="onRemove(true)">
                                    Delete
                                </button>
                            </div>
                        }
                    }
                </div>
            </form>
        </div>
    </div>
    
    <div mat-dialog-actions class="row mb-5">
        <button type="button" mat-button class="btn btn-primary" (click)="closeEventDialog()">Close</button>
    </div>
</div>


